import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
const API_URL = import.meta.env.VITE_API_URL;

const InspectionAnswer = {
    NOTHING_NEW: 'regular',
    DAMAGED: 'danificado',
    MISSING: 'ausente',
    IRREGULAR: 'irregular'
};

const ReportContent = ({data, tableColumns}) => {

    useEffect(() => {
        ReportUtils.createExportableTable(null, null, `Vistoria de veículos das guarnições`, "garrison-inspection");
    }, [data, tableColumns]);

    const createInspectionAnswer = (answers) => {

        let newsAnswers = [];
        const newAnswers = JSON.parse(answers);


        newAnswers.map(answer => {
            if (answer.answer != 'NOTHING_NEW') {
                newsAnswers.push(answer.item + ' ' + InspectionAnswer[answer.answer]);
            }
        });

        if (newsAnswers.length == 0) {
            return '-';
        }

        let newsText = '';
        newsAnswers.map(news => {
            if (newsText.length > 0) {
                newsText += '; ';
            }

            newsText += news;
        });

        return newsText + '.';
    }

    const columns = [
        {id: "dt_create", label: "D/H da ação", renderCell: element => element.dt_create ?? ""},
        {id: "prefix", label: "Prefixo", renderCell: element => element.prefix ?? ""},
        {id: "plate", label: "Placa", renderCell: element => {
            const url = `${API_URL}/despacho/garrison/form/${element.garrison_id}`;
            return <a className="print:!text-black" target="_blank" href={url}>{element.plate || " "}</a>;
        }},
        {id: "user", label: "Inspecionado por", renderCell: element => element.user ?? ""},
        {id: "answers", label: "QRU", renderCell: element => createInspectionAnswer(element.answers)}
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    return (
        <>
            {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table id="garrison-inspection" className={`table report-table ${visibleColumns.length === 0 ? "hidden" : ""}`} sheet-name="Vistoria de veículos das guarnições">
                <thead className="thead-background">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id}>{tableColumns?.[column.id]?.label ?? column.label}</th>)}
                    </tr>
                </thead>

                <tbody className="bg-white">
                    {data.map((element, index) => (
                        <tr key={index} className="table-break-word">
                            {visibleColumns.map(column => <td key={column.id}>{column.renderCell(element)}</td>)}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;